import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
//import { NgwWowService } from 'ngx-wow';
import { DataService, EmmiterService } from 'src/app/services/data.service';
import { HttpParams } from '@angular/common/http';
import { CommonService } from 'src/app/services/common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { AdvanceGridviewComponent } from 'src/app/shared/components/advance-gridview/advance-gridview.component';
import { DropdownMultiselectComponent } from 'src/app/shared/components/dropdown-multiselect/dropdown-multiselect.component';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import { MemoryStorageService } from 'src/app/services/memory-storage.service';
import { MagnifyFieldSearchComponent } from 'src/app/shared/components/magnify-field-search/magnify-field-search.component';

@Component({
  selector: 'app-opensearch',
  templateUrl: './opensearch.component.html',
  styleUrls: ['./opensearch.component.css'],
})
export class OpensearchComponent implements OnInit {
  advanceSearchFields: any = [];
  filterDocumentTypeId: any = [];
  advanceSearchSummaryFields: any = [];
  advanceSearchFilterFields: any = [];
  docTypeList: any = [];
  selectedDocType: number = 0;
  selectedDocumentType: { docTypeId: number, docTypeName: string } = { docTypeId: 0, docTypeName: '' };
  // Grid Data Model//
  selectedWorklistId: number = 1;
  advanceSearchGridData: any = [];
  advanceSearchColumnsToHide: any = ['id', 'DOCUMENT_DETAIL_ID'];
  lstURN: any = "";
  invoiceAmount: any = "";
  //Document Type Dropdown Property
  @ViewChild('ddlWorkItem') ddlWorkItem: DropdownMultiselectComponent;
  @ViewChild('ddlDocselect') ddlDocmultiselect: DropdownMultiselectComponent;
  @ViewChild('ddlProcessmultiselect')
  ddlProcessmultiselect: DropdownMultiselectComponent;
  @ViewChild('ddlPriority') ddlPriority: DropdownMultiselectComponent;
  //Added by imran 08-01-2026
  @ViewChild('invoiceSubmittedModal') invoiceSubmittedModal: ElementRef;
  @ViewChild('gridTransactionData') gridAllocationData: AdvanceGridviewComponent;
  lstProcess: any = [];
  lstPriority: any = [
    { value: 'NORMAL', text: 'Normal' },
    // { value: 'MEDIUM', text: 'Medium' },//'Medium', arun decided to remove from the priority 
    //discussed and confirmed on 13-06-2022.
    { value: 'HiGH', text: 'High' },
  ];
  // Invoice Creation Range
  isDateRangeHasValue = false;
  maxDate = new Date();
  invoiceCreationDateRange = new FormGroup({
    start_date: new FormControl(),
    end_date: new FormControl(),
  });

  constructor(
    //private wowService: NgwWowService,
    private dataService: DataService,
    public commonService: CommonService,
    private modalService: NgbModal,
    private route: Router,
    private encryptDecryptservice: EncryptDecryptService,
    private memorystore: MemoryStorageService
  ) {
    //wowService.init();
  }

  ngOnInit(): void {
    this.getProcessStep();
    this.getDocumentTypes();
  }

  getProcessStep() {
    this.lstProcess = [];
    let params = new HttpParams();
    // params = params.append('project_id', this.commonService.selectedProject);
    params = params.append('project_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject));
   params = params.append('xusrid', this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')));
    this.dataService.getData('process-type', params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res.data != null) {
          res.data.forEach((element) => {
            this.lstProcess.push({
              value: element.process_id,
              text: element.process_name,
            });
          });
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
      });
  }

  getDocumentTypes() {
    this.docTypeList = [];
    let params = new HttpParams();
    // params = params.append('project_id', this.commonService.selectedProject);
    // params = params.append('subgroup_id', this.commonService.selectedSubgroup);
    params = params.append('project_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject));
    params = params.append('subgroup_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedSubgroup));
    params = params.append('xusrid', this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')));

    this.dataService.getData('document-types', params).subscribe(
      (res) => {
        if (res != null && (res.error_message == null || res.error_message == "")) {
          if (res.data != null) {
            res.data.forEach((element) => {
              this.filterDocumentTypeId.push(element.document_type_id);
              this.docTypeList.push({
                value: element.document_type_id,
                text: element.document_type_name,
                selected: true,
              });
            });
            this.selectedDocType = res.data[0].document_type_id;
          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.route.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
        //this.getAdvanceSearchFields();
      },
      error => {
        if (error.includes("401")) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
      }
    );
  }

  getAdvanceSearchFields(selectedDocs: any) {
    this.advanceSearchFields = [];
    let _userId = this.memorystore.getItem('userId')
    let reqData = {
      project_id: this.commonService.selectedProject,
      subgroup_id: this.commonService.selectedSubgroup,
      document_type_ids: selectedDocs.toString(),
      source: '',//this.filterDocumentTypeId.toString()
      xusrid : this.encryptDecryptservice.encryptUsingAES256(_userId)//Added by imran on 01-04-26
    };
    this.dataService.postData('advance-search', reqData).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (
          res != null &&
          res != undefined &&
          res.data != null &&
          res.data.length > 0
        ) {
          if (res != null && res.data != null) {
            this.advanceSearchFields = res.data;
            this.advanceSearchFields.forEach(async (element) => {
              element['search_value'] = '';
              if (element.control_type == 'TEXTBOX') {
                element.value_type =
                  element.validation_type == 'NUMERIC' ? 'number' : 'text';
              }
              //Commented by imran 08-01-2026
              //if (element.control_type == 'DROPDOWN' && element.is_magnify_search != 1) {
              if (element.control_type == 'DROPDOWN') {
                element.options = await this.commonService.getDropdownData(
                  element.field_mapping_detail_id
                );
                element.options.splice(0, 0, { id: 0, name: '-- Select --' });
              }
            });
          }
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
      });

  }

  openFilterFieldMagnifySearchModal(field: any) {

    let dependantFieldValues = {};
    if (field.magnify_dependant_fields != null) {
      let magnifyDependantFields = JSON.parse(field.magnify_dependant_fields);
      Object.keys(magnifyDependantFields).forEach(x => {
        let field = this.advanceSearchFields.find(f => f.db_column_name == magnifyDependantFields[x]);
        if (field != undefined) {
          let field_value = field.search_value;
          if (field_value != null && field_value != '' && field_value != undefined) {
            // if (field.control_type == 'DROPDOWN') {
            //   field_value = field.options.find(d => d.id == field_value).name;
            // }
            dependantFieldValues[x] = field_value.toString();
          }
        }

      });
    }

    const modalRef = this.modalService.open(MagnifyFieldSearchComponent, {
      size: 'xl',
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
    modalRef.componentInstance.fieldMappingDetailId = field.field_mapping_detail_id;
    modalRef.componentInstance.dependantFieldValues = dependantFieldValues;
    modalRef.componentInstance.predefinedTableTextColumnName = field.predefined_table_column_name;
    modalRef.componentInstance.selectRecord.subscribe((res) => {
      const selectedField = this.advanceSearchFields.find(
        (x) => x.field_mapping_detail_id == res.fieldId
      );
      selectedField.search_value = res.fieldValue;
      if (selectedField.control_type == 'DROPDOWN') {
        selectedField.options = [{ id: res.fieldValue, name: res.selectedText }];
        // if dependent field in advance search then add code here
      }
      modalRef.close();
    });
    modalRef.componentInstance.closeModal.subscribe(() => {
      modalRef.close();
    });
  }

  // Grid Data Event//
  advanceSearchCellClick(event: any) {
   if (event.columnName.toLowerCase() == 'urn') {
      let data = {
        documentDetailId: event.rowData['DOCUMENT_DETAIL_ID'],
        isReadonlyMode: true,
      }
      console.log("ID : " + event.rowData['DOCUMENT_DETAIL_ID']);
      //EmmiterService.get("transactionLiteModal").emit(data);
      const emitter = EmmiterService.get('transactionLiteModal');
      if (!emitter) {
        console.error('Emitter not found for channel: transactionLiteModal');
      } else {
        console.log('Emitter exists, emitting:', data);
        emitter.emit(data);
      }
    } else if (event.columnName.toLowerCase() == 'attachment') {
      this.commonService.openAttachment(event.rowData.URN, '');
    }
  }

  getOpenSearchData() {
    let validationStatus: boolean = true;
    let validationMessage: string = '';
    let selectedDocumentTypes: any = [this.selectedDocType];//[];
    let selectedProcessIds: any = [];
    let selectedPriorities: any = [];
    let selectedWorklistIds: any = [];
    let dateRange: any = { start_date: '', end_date: '' };

    this.ddlPriority.onDropdownOptionClick();
    //this.ddlDocmultiselect.onDropdownOptionClick();
    this.ddlProcessmultiselect.onDropdownOptionClick();

    //selectedDocumentTypes = this.ddlDocmultiselect.selectedValues;
    selectedWorklistIds = this.ddlWorkItem.selectedValues;
    selectedProcessIds = this.ddlProcessmultiselect.selectedValues;
    selectedPriorities = this.ddlPriority.selectedValues;
    dateRange = {
      start_date: this.commonService.dateFormating(
        this.invoiceCreationDateRange.value.start_date
      ),
      end_date: this.commonService.dateFormating(
        this.invoiceCreationDateRange.value.end_date
      ),
    };

    if (selectedDocumentTypes.length <= 0) {
      validationMessage += '- Please fill the required field(s).\r <br/>';
      validationMessage += '- Select atleast one Work Item Type.\r <br/>';
      validationStatus = false;
    }

    if (!validationStatus) {
      this.commonService.showMessageBox(validationMessage, 'Alert');
      return;
    }

    let searchColumns = {};
    this.advanceSearchFields.forEach((field) => {
      if (field.search_value != '') {
        if (field.control_type == 'DATE') {
          field.search_value = this.commonService.dateFormating(
            field.search_value
          );
        }
        searchColumns[field.db_column_name] = field.search_value.toString();
      }
    });

    let reqData = {
      // project_id: this.commonService.selectedProject,
      // role_id: this.commonService.selectedRole,
      projectId: this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject),
      roleId: this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedRole),
      subgroup_id: this.commonService.selectedSubgroup,
      // user_id: this.commonService.getUserInfoFromLocalStorage('userId'),
      // user_id: this.memorystore.getItem('userId'),
      worklist_ids: selectedWorklistIds,
      document_type_ids: this.selectedDocType.toString(),// this.ddlDocmultiselect.selectedValues.toString(),
      process_ids: selectedProcessIds.toString(),
      search_columns: searchColumns,
      priority: selectedPriorities,
      date_range: dateRange,
      urn: this.lstURN,
      invoiceAmountRange: this.invoiceAmount
    };

    this.advanceSearchGridData = [];
    this.dataService.postData('open-search', reqData).subscribe((res) => {
      if (
        res != null &&
        res != undefined &&
        res.data != null &&
        res.data.length > 0
      ) {
        //this.lstHeader_search = res.data[0].table_sections
        this.advanceSearchGridData = res.data[0].table_data;
        //this.isDisplaySearchGrid = true;
        if (this.advanceSearchGridData.length <= 0) {
          this.commonService.showMessageBox('No data found', 'Information');
        }
      }
      else {
        this.commonService.showMessageBox('No data found', 'Information');
      }
    });
  }

  ClearOpenSearch() {
    this.advanceSearchFields.forEach((field) => {
      field.search_value = '';
    });
    this.lstURN = '';
    this.invoiceAmount = '';
    this.advanceSearchGridData = [];
    this.ddlDocmultiselect.allSelected = true;
    this.ddlDocmultiselect.ngAfterViewInit();
    this.ddlPriority.allSelected = true;
    this.ddlPriority.ngAfterViewInit();
    this.ddlProcessmultiselect.allSelected = true;
    this.ddlProcessmultiselect.ngAfterViewInit();
    this.invoiceCreationDateRange = new FormGroup({
      start_date: new FormControl(),
      end_date: new FormControl(),
    });
    this.isDateRangeHasValue = false;
  }

  onInvoiceCreationDateChanges() {
    if (
      this.invoiceCreationDateRange.value.start_date != '' ||
      this.invoiceCreationDateRange.value.end_date != ''
    ) {
      this.isDateRangeHasValue = true;
    }
  }

  resetInvoiceCreationDateRange() {
    this.invoiceCreationDateRange = new FormGroup({
      start_date: new FormControl(),
      end_date: new FormControl(),
    });
    this.isDateRangeHasValue = false;
  }
  setDecimalPlaces(value: any, decimalPlace: number, validationType: string) {
    return validationType.toLowerCase() == 'numeric' ? parseFloat(value == '' ? 0 : value).toFixed(Number(decimalPlace)) : value;
  }
  onWorkItemSelect($event) {
    if ($event.selectedValues.length === 0) {
      this.commonService.showMessageBox('Please select the work item type', 'Information');
      return;
    }
    this.getAdvanceSearchFields($event.selectedValues.toString());
  }

}
